import { makeStyles } from '@rbx/ui';

const useContentTableStyles = makeStyles()((theme) => ({
  tableContainer: {
    width: '100%',
    [theme.breakpoints.down('Large')]: {
      overflowX: 'auto',
    },
  },
}));

export default useContentTableStyles;
